export function getFormArea(props, listener) {
  /*
    props =
      value, outer_style, inner_style, text_class, max_length,
      input_type, placeholder
  */
  if (props.outer_style === undefined) { props.outer_style = {}; }
  if (props.text_class === undefined) { props.text_class = ''; }
  if (props.inner_style === undefined) { props.inner_style = {}; }
  if (props.max_length === undefined) { props.max_length = 500; }
  if (props.placeholder === undefined) { props.placeholder = ''; }
  if (props.is_active === undefined) { props.is_active = true; }
  if (!props.is_active) {
    props.inner_style.pointerEvents = 'none';
    props.inner_style.fontStyle = 'italic';
  }
  if (listener === undefined) { listener = null; }
  return (
    <div id={props.id} style={{...m_style.input_wrapper_b, ...props.outer_style}}>
      <textarea
        disabled = {props.disabled}
        maxLength={props.max_length}
        value={props.value}
        type={props.input_type}
        placeholder={props.placeholder}
        className={props.text_class}
        style={{...m_style.inner_form, ...props.inner_style}}
        onChange={(e) => {if(listener !== null) {listener(e.target.value);}}}
      />
    </div>
  );
}

export function getFormInput(props, listener) {
  /*
    props =
      value, outer_style, inner_style, text_class, max_length,
      input_type, placeholder
  */
  if (props.outer_style === undefined) { props.outer_style = {}; }
  if (props.text_class === undefined) { props.text_class = ''; }
  if (props.inner_style === undefined) { props.inner_style = {}; }
  if (props.max_length === undefined) { props.max_length = 500; }
  if (props.placeholder === undefined) { props.placeholder = ''; }
  if (props.input_type === undefined) { props.input_type = 'text'; }
  if (props.is_active === undefined) { props.is_active = true; }
  if (!props.is_active) {
    props.inner_style.pointerEvents = 'none';
    props.inner_style.fontStyle = 'italic';
  }
  if (listener === undefined) { listener = null; }
  return (
    <div id={props.id} style={{...m_style.input_wrapper_a, ...props.outer_style}}>
      <input
        disabled = {props.disabled}
        maxLength={props.max_length}
        value={props.value}
        type={props.input_type}
        placeholder={props.placeholder}
        className={props.text_class}
        style={{...m_style.inner, ...props.inner_style}}
        onChange={(e) => {if(listener !== null) {listener(e.target.value);}}}
      />
    </div>
  );
}

export function getFormYesNo(props, listener) {
  /*
    props =
      value, outer_style, inner_style, text_class,
      placeholder, is_active, disabled
  */

  // Default value
  if (props.outer_style === undefined) { props.outer_style = {}; }
  if (props.text_class === undefined) { props.text_class = ''; }
  if (props.inner_style === undefined) { props.inner_style = {}; }
  if (props.placeholder === undefined) { props.placeholder = ''; }
  if (props.is_active === undefined) { props.is_active = true; }
  if (!props.is_active) {
    props.inner_style.pointerEvents = 'none';
    props.inner_style.fontStyle = 'italic';
  }
  if (listener === undefined) { listener = null; }

  return (
    <div id={props.id} style={{ ...m_style.input_wrapper_a, ...props.outer_style }}>
      <select
        disabled={props.disabled}
        value={props.value}
        className={props.text_class}
        style={{ ...m_style.inner_form, ...props.inner_style }}
        onChange={(e) => { if (listener !== null) { listener(e.target.value); } }}
      >
        <option value="">{props.placeholder || '-- Select --'}</option>
        <option value="YES">Yes</option>
        <option value="NO">No</option>
      </select>
    </div>
  );
}


const m_style = {
  input_wrapper_a : {
    display : 'flex',
    height : 40,
    flexDirection : 'row'
  },
  input_wrapper_b : {
    height : 200,
    display : 'flex'
  },
  inner : {
    paddingLeft : 10,
    paddingRight : 10,
    background : 'transparent',
    outline : 'none',
    borderWidth : 0,
    flex : 1
  },
  inner_form : {
    resize : 'none',
    padding : 10,
    background : 'transparent',
    outline : 'none',
    borderWidth : 0,
    flex : 1
  }
}
